<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="baseCustomerPropertyValueMappings">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.materialNO" clearable/>
          </vm-search>
          <vm-search label="客户特性名">
            <el-input v-model.trim="filter.customerProperyName" clearable/>
          </vm-search>
          <vm-search label="SAP特性名">
            <el-input v-model.trim="filter.sapPropertyName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="materialNO" align="center" label="物料编号"/>
      <el-table-column prop="materialDesc" align="center" label="物料描述"/>
      <el-table-column prop="customerProperyName" align="center" label="客户特性名"/>
      <el-table-column prop="customerProperyValue" align="center" label="客户特性值"/>
      <el-table-column prop="sapPropertyName" align="center" label="SAP特性名"/>
      <el-table-column prop="sapPropertyDesc" align="center" label="SAP特性描述"/>
      <el-table-column prop="sapPropertyValue" align="center" label="SAP特性值"/>
      <el-table-column prop="sapPropertyValueDesc" align="center" label="SAP特性值描述"/>
      <el-table-column prop="propertyNickName" align="center" label="别名"/>
      <el-table-column prop="sapRequire" width="95" align="center" label="是否导入SAP">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.sapRequire === true">
            是
          </el-tag>
          <el-tag v-else>
            否
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="dataType" align="center" label="数据类型">
        <template slot-scope="scope">
          <span v-if="scope.row.dataType === 1002">
            浮点型
          </span>
          <span v-else-if="scope.row.dataType === 1004">
            枚举型
          </span>
          <span v-else>
            {{scope.row.dataType}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <s-a-p-base-customer-material-mapping-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import SAPBaseCustomerMaterialMappingEdit
    from "@/views/information/SAPBaseCustomerPropertyValueMapping/SAPBaseCustomerMaterialMappingEdit";

  export default {
    name: "SAPBaseCustomerPropertyValueMapping",
    components: {SAPBaseCustomerMaterialMappingEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        show: "",
        filter: {
          materialNO: "",
          customerProperyName: "",
          sapPropertyName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","/baseCustomerPropertyValueMappings",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
